/**
 * A generic queue class
 */
export class Queue<T> {

   private _store: T[] = [];

   public size() {
      return this._store.length;
   }

   public isEmpty() {
      return this.size() === 0;
   }

   public clear() {
      this._store.length = 0;
   }

   public push(val: T) {
      this._store.push(val);
   }

   public pop(): T | undefined {
      return this._store.shift();
   }

   public toArray(): T[] {
      return Array.from(this._store);
   }

   public fromArray(array: T[]) {
      this._store = Array.from(array);
   }
}
